import styled from "styled-components";


export const StyledFollowUp = styled.div`
  margin-top: 2rem;
  padding-bottom: 8rem;

  tr {
    .last-updated,
    .table-controls {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1rem;
    }

    .last-updated {
      @media screen and (pointer: coarse) {
        display: none;
      }
    }

    @media screen and (pointer: fine) {
      &:hover {
        .table-controls {
          opacity: 1;
          z-index: 1;
          pointer-events: all;
        }

        .last-updated {
          opacity: 0;
          pointer-events: none;
          z-index: -1;
        }
      }

      .table-controls {
        opacity: 0;
        z-index: -1;
        pointer-events: none;

        &:focus-within {
          opacity: 1;
          z-index: 1;
          pointer-events: all;

          & + .last-updated {
            opacity: 0;
          }
        }
      }
    }
  }
`;
